module.exports = __webpack_public_path__ + "img/vk.4b5fcfd3.svg";